import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state() {
    return {
      mutateController: null,
      mutateLoading: false,
      fetchController: null,
      fetchLoading: false
    }
  },
  getters,
  actions,
  mutations
}
